import React from "react";
import { Modal, Table } from "antd";
import { translations } from "../../../utils/Translation/staticTranslation";

const LogsViewModal = ({ visible, onCancel, file }) => {
  const lang = localStorage.getItem("language") || "ar";
  const errorLogs = file?.logs
    ? file.logs.filter((log) => {
        return log.error_arabic ? log.error_arabic : log.row && log.error;
      })
    : [];

  const summaryLog = file?.logs
    ? file.logs.find((log) => log.total_products)
    : null;
  const product = translations[lang]?.productPage;
  const viewlogs = translations[lang]?.productPage?.bulk_upload_page?.viewLogs;
  const common_btn = translations[lang]?.common_btn;

  const columns = [
    {
      title: product?.productTableCol?.product_name,
      dataIndex: ["row", "product_name"],
      key: "product_name",
      render: (text) =>
        text || (
          <span className="missing-field">
            {" "}
            {lang === "ar" ? "مفقودة" : "Missing"}
          </span>
        ),
    },
    {
      title: product?.productTableCol?.category,
      dataIndex: ["row", "category"],
      key: "category",
      render: (text) =>
        text || (
          <span className="missing-field">
            {" "}
            {lang === "ar" ? "مفقودة" : "Missing"}
          </span>
        ),
    },
    {
      title: product?.productTableCol?.price,
      key: "price",
      render: (_, record) => (
        <span>
          {record.row.price_amount ? (
            `${record.row.price_amount} ${record.row.price_unit || ""}`
          ) : (
            <span className="missing-field">
              {" "}
              {lang === "ar" ? "مفقودة" : "Missing"}
            </span>
          )}
        </span>
      ),
    },
    {
      title: product?.productTableCol?.image,
      dataIndex: ["row", "image_url"],
      key: "image_url",
      render: (text) =>
        text ? (
          <span className="present-field">
            {lang === "ar" ? "موجود" : "Present"}
          </span>
        ) : (
          <span className="missing-field">
            {lang === "ar" ? "مفقودة" : "Missing"}
          </span>
        ),
    },
    {
      title: product?.productTableCol?.product_url,
      dataIndex: ["row", "product_url"],
      key: "product_url",
      render: (text) =>
        text ? (
          <span className="present-field">
            {" "}
            {lang === "ar" ? "موجود" : "Present"}
          </span>
        ) : (
          <span className="missing-field">
            {" "}
            {lang === "ar" ? "مفقودة" : "Missing"}
          </span>
        ),
    },
    {
      title: product?.productTableCol?.error,
      dataIndex: lang === "ar" ? "error_arabic" : "error",
      key: lang === "ar" ? "error_arabic" : "error",
      render: (text) => <span className="error-message">{text}</span>,
    },
  ];

  return (
    <Modal
      title={viewlogs?.file_upload_logs}
      open={visible}
      onCancel={onCancel}
      width={900}
      footer={[
        <button key="close" className="cancel-btn" onClick={onCancel}>
          {common_btn?.close}
        </button>,
      ]}
      className="logs-view-modal"
    >
      <div className="logs-modal-content">
        {summaryLog && (
          <div className="logs-summary-section">
            <div className="logs-summary-container">
              <div>
                <h5 className="logs-summary-title">
                  {viewlogs?.upload_summary}
                </h5>
              </div>
              <div className="logs-summary-stats">
                <div className="logs-summary-stat">
                  <strong>{viewlogs?.total_product}:</strong>{" "}
                  {summaryLog.total_products}
                </div>
                <div className="logs-summary-stat">
                  <strong>{viewlogs?.successfully_added}:</strong>{" "}
                  {summaryLog.total_products_added}
                </div>
              </div>
            </div>
          </div>
        )}

        {errorLogs.length > 0 ? (
          <>
            <h5 className="logs-failed-title">{viewlogs?.failed_entries}</h5>
            <Table
              dataSource={errorLogs}
              columns={columns}
              rowKey={(record, index) => `error-${index}`}
              pagination={{ pageSize: 5 }}
              scroll={{ x: 800 }}
              className="logs-error-table"
            />
          </>
        ) : (
          <div className="logs-no-errors">
            <p>{viewlogs?.no_error_logs}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default LogsViewModal;
